import { useQuery } from "@tanstack/react-query"
import { TrainingUserGet } from "../app/models/TrainingUser"
import { digitalManagerApi } from "../services/api"

export function useTrainingUsers(trainingId?: string, includeExpired = false) {
  const { data: trainingUsers = [], isLoading: isLoadingTrainingUsers } = useQuery({
    queryKey: ["trainingUsers", trainingId, includeExpired],
    queryFn: () =>
      digitalManagerApi
        .get<TrainingUserGet[]>(`/trainings/${trainingId}/users`, {
          params: { includeExpired },
        })
        .then((r) => r.data),
    enabled: !!trainingId,
  })

  return {
    trainingUsers,
    isLoadingTrainingUsers,
  }
}
